import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { COLORS, FONTS, SPRING } from "./constants";
import { GridBackground } from "./components/GridBackground";

const STATS = [
  { value: "670+", label: "Documents Indexed", color: COLORS.accentBlue },
  { value: "1536", label: "Embedding Dimensions", color: COLORS.accentPurple },
  { value: "<4s", label: "Query Response Time", color: COLORS.accentTeal },
  { value: "5", label: "Source Integrations", color: COLORS.accentOrange },
];

export const Scene8Outro: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Final fade out
  const fadeOut = interpolate(frame, [100, 120], [1, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ opacity: fadeOut }}>
      <GridBackground opacity={0.08} />

      {/* Stats row */}
      <div
        style={{
          position: "absolute",
          top: "35%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          gap: 80,
        }}
      >
        {STATS.map((stat, i) => {
          const statAppear = spring({
            frame: frame - i * 8,
            fps,
            config: SPRING.bouncy,
          });

          const scale = interpolate(statAppear, [0, 1], [0.5, 1]);
          const opacity = interpolate(statAppear, [0, 1], [0, 1]);

          return (
            <div
              key={i}
              style={{
                textAlign: "center",
                transform: `scale(${scale})`,
                opacity,
              }}
            >
              <div
                style={{
                  fontSize: 56,
                  fontFamily: FONTS.heading,
                  fontWeight: 800,
                  color: stat.color,
                  textShadow: `0 0 30px ${stat.color}40`,
                }}
              >
                {stat.value}
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontFamily: FONTS.body,
                  color: COLORS.textMuted,
                  marginTop: 8,
                }}
              >
                {stat.label}
              </div>
            </div>
          );
        })}
      </div>

      {/* URL */}
      {(() => {
        const urlAppear = spring({
          frame: frame - 40,
          fps,
          config: SPRING.gentle,
        });

        const glowPulse = interpolate(
          Math.sin(frame * 0.06),
          [-1, 1],
          [15, 35],
        );

        return (
          <div
            style={{
              position: "absolute",
              top: "58%",
              left: "50%",
              transform: "translate(-50%, 0)",
              textAlign: "center",
              opacity: interpolate(urlAppear, [0, 1], [0, 1]),
            }}
          >
            <div
              style={{
                fontSize: 28,
                fontFamily: FONTS.mono,
                fontWeight: 600,
                color: COLORS.accentTeal,
                textShadow: `0 0 ${glowPulse}px ${COLORS.accentTeal}60`,
                letterSpacing: 1,
              }}
            >
              eakc.adaptivesmartsystems.cc
            </div>
            <div
              style={{
                fontSize: 16,
                fontFamily: FONTS.body,
                color: COLORS.textMuted,
                marginTop: 12,
              }}
            >
              Enterprise AI Knowledge Chat — Built with Next.js, Supabase & OpenRouter
            </div>
          </div>
        );
      })()}

      {/* Tech stack badges */}
      {(() => {
        const badgesAppear = spring({
          frame: frame - 60,
          fps,
          config: SPRING.snappy,
        });

        const techs = [
          "Next.js 15",
          "Supabase",
          "pgvector",
          "OpenRouter",
          "Upstash Redis",
          "MCP Protocol",
        ];

        return (
          <div
            style={{
              position: "absolute",
              top: "72%",
              left: "50%",
              transform: "translate(-50%, 0)",
              display: "flex",
              gap: 16,
              opacity: interpolate(badgesAppear, [0, 1], [0, 1]),
            }}
          >
            {techs.map((tech, i) => (
              <div
                key={i}
                style={{
                  padding: "6px 16px",
                  borderRadius: 20,
                  background: `${COLORS.bgCard}`,
                  border: `1px solid ${COLORS.borderLight}`,
                  fontFamily: FONTS.mono,
                  fontSize: 13,
                  color: COLORS.textSecondary,
                }}
              >
                {tech}
              </div>
            ))}
          </div>
        );
      })()}

      {/* Brand line */}
      {(() => {
        const brandAppear = spring({
          frame: frame - 75,
          fps,
          config: SPRING.gentle,
        });
        return (
          <div
            style={{
              position: "absolute",
              bottom: 80,
              left: "50%",
              transform: "translate(-50%, 0)",
              opacity: interpolate(brandAppear, [0, 1], [0, 1]),
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontFamily: FONTS.heading,
                fontWeight: 600,
                color: COLORS.textSecondary,
              }}
            >
              Adaptive Smart Systems
            </div>
            <div
              style={{
                fontSize: 13,
                fontFamily: FONTS.body,
                color: COLORS.textMuted,
                marginTop: 4,
              }}
            >
              Unify · Search · Understand
            </div>
          </div>
        );
      })()}
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
